import { jsx as a, jsxs as g } from "react/jsx-runtime";
import { forwardRef as R } from "react";
import { Box as o, Radio as u, VStack as x } from "@chakra-ui/react";
import { useRadioGroupContext as b } from "./useRadioGroupContext.mjs";
import { Badge as N } from "../../dataDisplay/Badge/Badge.mjs";
const j = R((e, t) => {
  const { children: r, id: s, isDisabled: c, size: n = "md", value: d, ...m } = e, { getRadioProps: l, variant: i, id: p } = b(), f = l({ value: d }), h = s ?? [p, d].join("-");
  return (
    // applying style props directly to ChakraRadio doesn't work properly.
    /* @__PURE__ */ a(o, { w: "fit-content", ...m, children: /* @__PURE__ */ a(
      u,
      {
        ref: t,
        ...f,
        id: h,
        isDisabled: c,
        size: n,
        variant: i,
        children: i === "card" ? /* @__PURE__ */ g(x, { align: "stretch", spacing: { base: 2, md: 3 }, children: [
          /* @__PURE__ */ a(o, { className: "radio-card-badge-container", children: /* @__PURE__ */ a(N, { className: "radio-card-selected-badge", status: "recommendation", children: "Selected" }) }),
          /* @__PURE__ */ a(o, { className: "radio-card-child-container", children: r })
        ] }) : r
      }
    ) })
  );
});
j.displayName = "Radio";
export {
  j as Radio
};
